import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";

export const SubmitFindingsTaskAttemptSchema = z.object({
  type: z.literal(TaskType.SUNRUN_SUBMIT_FINDINGS),
  projectId: z.number(),
  reason: z.enum(["WO_STATUS_NOT_READY", "FSD_STATUS_NOT_READY", "SUBMISSION_FAILED"]),
});

export type SubmitFindingsTaskAttempt = z.infer<typeof SubmitFindingsTaskAttemptSchema>;
